import React from 'react'

export type SpacerProps = {
  height?: number
  width?: number
}

const Spacer = (props: SpacerProps) => {
  return <div style={{ height: props?.height ?? 80, width: props?.width ?? '100%' }} />
}

export default Spacer
